import Link from 'next/link';
import Image from 'next/image';
import convertImageBase64 from '../../../helpers/utils/convertImage';
import Head from 'next/head';
import ImageZoomModal from '../../atoms/ImageZoomModal';

interface DetailArticleHeroSectionProps {
  /* eslint-disable-next-line */
  bannerLink?: any;
  /* eslint-disable-next-line */
  image: any;
  /* eslint-disable-next-line */
  altImage: any;
}

const DetailArticleHeroSection = ({
  bannerLink,
  image,
  altImage,
}: DetailArticleHeroSectionProps) => {
  return (
    <section className="mb-6 lg:mb-10 md:mt-5">
      <Head>
        <link rel="preload" as="image" href={image} imageSizes="50vw" />
      </Head>
      <div className="">
        {bannerLink ? (
          <Link href={bannerLink}>
            <Image
              className="px-0 w-full aspect-video"
              src={image}
              alt={altImage}
              width={500}
              height={500}
              sizes="(min-width: 1240px) 791px, (min-width: 1040px) 645px, calc(100vw - 17px)"
              priority={true}
              quality={75}
              placeholder="blur"
              blurDataURL={`data:image/svg+xml;base64,${convertImageBase64(1240, 698)}`}
            />
          </Link>
        ) : (
          <ImageZoomModal
            classname="z-[200] [&_.zoom-modal-hide]:hidden [&_.zoom-modal-content]:h-full [&_.zoom-modal-content]:rounded-none"
            isWidthAuto={false}
          >
            <Image
              className="px-0 w-full aspect-video"
              src={image}
              alt={altImage}
              width={500}
              height={500}
              sizes="(min-width: 1240px) 791px, (min-width: 1040px) 645px, calc(100vw - 17px)"
              priority={true}
              quality={75}
              placeholder="blur"
              blurDataURL={`data:image/svg+xml;base64,${convertImageBase64(1240, 698)}`}
            />
          </ImageZoomModal>
        )}
      </div>
    </section>
  );
};

export default DetailArticleHeroSection;
